'use es6';

import { APPLICATION_SETTINGS_USER_SAVE, CODEMIRROR_SESSION_SAVE, CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE, FINDER_OPTIONS_SAVE, LAYOUT_EDITOR_OPTIONS_SAVE, PREVIEW_OPTIONS_SAVE, TABS_SAVE } from 'DesignData/actions/ActionTypes';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { KEY_REGEX as LOCALSTORAGE_KEY_REGEX } from 'DesignData/lib/localStorage';
import { getPortalId, getUserId } from 'DesignData/selectors/auth';
const LOCALSTORAGE_LEGACY_REGEX = /^design-manager:(\d+):/;

function getIdsFromLocalStorageKey(key) {
  if (!key) return EMPTY_OBJECT; // Legacy DMUI and template_builder keys

  {
    const matches = key.match(LOCALSTORAGE_LEGACY_REGEX);

    if (matches) {
      const [, portalId] = matches;
      return {
        portalId
      };
    }
  } // IDE keys

  {
    const matches = key.match(LOCALSTORAGE_KEY_REGEX);

    if (matches) {
      const [,, userId, portalId] = matches;
      return {
        userId,
        portalId
      };
    }
  }
  return EMPTY_OBJECT;
}
/**
 * Remove all IDE localStorage items not related
 * to the current user and/or portal.
 *
 * @param {*} dispatch
 * @param {*} getState
 */


function cleanupIdeLocalStorage(dispatch, getState) {
  try {
    const state = getState();

    const __portalId = getPortalId(state);

    const __userId = getUserId(state);

    Object.keys(localStorage).forEach(key => {
      const {
        userId,
        portalId
      } = getIdsFromLocalStorageKey(key); // Matches will be strings, not integers.

      /* eslint-disable eqeqeq */

      if (portalId && portalId != __portalId || userId && userId != __userId) {
        localStorage.removeItem(key);
      }
      /* eslint-enable eqeqeq */

    }); // TODO: Log remove count
  } catch (e) {// TODO: Log error and attempted remove count.
    // TODO: Alert user that their localStorage is full?
  }
}
/**
 * Middleware
 */


export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);

  switch (result.type) {
    case APPLICATION_SETTINGS_USER_SAVE:
    case CODEMIRROR_SESSION_SAVE:
    case CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE:
    case FINDER_OPTIONS_SAVE:
    case LAYOUT_EDITOR_OPTIONS_SAVE:
    case PREVIEW_OPTIONS_SAVE:
    case TABS_SAVE:
      {
        const {
          error
        } = result; // localStorage capacity reached. Clear items.

        if (error && error instanceof DOMException && (error.name === 'QuotaExceededError' || error.code === DOMException.QUOTA_EXCEEDED_ERR)) {
          cleanupIdeLocalStorage(dispatch, getState);
        }

        break;
      }

    default:
      break;
  }

  return result;
});